<template>
  <ActivityHistoryTable
    :title="text.title"
    :subtitle="text.subtitle"
    :loading="loading"
    :rows="rows"
    :loading-text="text.loading"
    :empty-text="text.empty"
    :headers="text.table.headers"
    :row-fallback="text.fallback"
  />
</template>

<script>
import ActivityHistoryTable from '@/components/common/ActivityHistoryTable.vue';
import financialAccountsService from '@/services/financialAccounts';
import { extractPayload } from '@/utils/dataNormalization';
import { formatDateTimeShort } from '@/utils/datePresentation';

export default {
  name: 'FinancialHistoryTab',
  components: {
    ActivityHistoryTable,
  },
  props: {
    text: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      rows: [],
      requestToken: 0,
    };
  },
  created() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      this.loading = true;
      const token = this.requestToken + 1;
      this.requestToken = token;

      try {
        const response = await financialAccountsService.history({ per_page: 200 });
        if (token !== this.requestToken) {
          return;
        }

        const payload = extractPayload(response);
        const rows = Array.isArray(payload?.rows)
          ? payload.rows
          : Array.isArray(payload?.data)
            ? payload.data
            : [];

        this.rows = rows
          .map((row) => this.mapHistoryRow(row))
          .filter((row) => row !== null);
      } catch (error) {
        if (token === this.requestToken) {
          this.rows = [];
        }
      } finally {
        if (token === this.requestToken) {
          this.loading = false;
        }
      }
    },
    mapHistoryRow(raw) {
      if (!raw || typeof raw !== 'object') {
        return null;
      }

      const moduleCode = String(raw.module || '').trim().toLowerCase();
      const eventType = String(raw.event_type || '').trim().toLowerCase();
      const dateSource = raw.happened_at || raw.created_at || raw.date_label;
      const accountName = String(raw.financial_account_name || '').trim();
      const description = String(raw.description_label || raw.description || raw.title || '').trim();

      return {
        id: Number(raw.id || 0) || `${moduleCode}-${eventType}-${Date.now()}`,
        date_label: formatDateTimeShort(dateSource, { fallback: this.text.fallback.date }),
        module_label: String(raw.module_label || '').trim() || this.toTitle(moduleCode) || this.text.fallback.module,
        event_label: String(raw.event_label || '').trim() || this.toTitle(eventType) || this.text.fallback.event,
        description_label: [description, accountName !== '' ? `Cuenta: ${accountName}` : '']
          .filter((value) => String(value || '').trim() !== '')
          .join(' | ') || this.text.fallback.description,
        actor_label: String(raw.actor_label || raw.actor_name || this.text.fallback.actor).trim(),
      };
    },
    toTitle(value) {
      const normalized = String(value || '').trim().replace(/[_-]+/g, ' ');
      if (normalized === '') {
        return '';
      }

      return normalized.charAt(0).toUpperCase() + normalized.slice(1);
    },
  },
};
</script>
